import { render } from "./AlertsKPIs.vue?vue&type=template&id=a14dcf0c&scoped=true&ts=true"
import script from "./AlertsKPIs.vue?vue&type=script&lang=ts"
export * from "./AlertsKPIs.vue?vue&type=script&lang=ts"

import "./AlertsKPIs.vue?vue&type=style&index=0&id=a14dcf0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a14dcf0c"]])

export default __exports__